<!-- 制作印章 -->
<template>
    <page-container class="seal-create">
        <el-breadcrumb slot="header"
                       separator="/"
                       v-if="!hideNavigate">
            <el-breadcrumb-item :to="{ path: '/home' }"
                                replace>电子印章</el-breadcrumb-item>
            <el-breadcrumb-item><a>印章备案</a></el-breadcrumb-item>
        </el-breadcrumb>

        <p class="tip small-font">
            <span @click="$router.push('/home')"
                  v-if="!hideNavigate">&lt;返回上一页</span>
        </p>
        <div class="create-form-container"
             v-if="!showCropper">
            <h3 class="text-center">印章备案</h3>

            <el-form label-width="160px"
                     :model="form"
                     :rules="rules"
                     ref="create"
                     class="create-form"
                     label-position="right">
                <el-form-item label="印章名称："
                              prop="seal_name">
                    <el-input placeholder="请输入印章名称"
                              class="form-item-width"
                              :maxlength="50"
                              v-model="form.seal_name"></el-input>
                </el-form-item>

                <el-form-item label="上传印章图片："
                              prop="pic_key">
                    <div class="horizonal-conatiner">
                        <div>
                            <el-upload class="upload-component form-item-width"
                                       drag
                                       action=""
                                       :show-file-list="false"
                                       accept="image/png, image/jpeg, image/gif, image/jpg"
                                       :before-upload="uploadImg">
                                <template v-if="form.pic_key">
                                    <img :src="imgUrl"
                                         class="middle-center"
                                         alt="">
                                    <div class="img-model transfrom-center">
                                        <div class="text-center">
                                            <i class="iconshangchuan1 upload-icon white-text"></i>
                                            <p>重新上传</p>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <i class="iconshangchuan1 grey-text upload-icon"></i>
                                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                </template>

                                <div class="el-upload__tip tip small-text text-center"
                                     slot="tip">支持图片格式：jpg、jpeg、png、gif</div>
                            </el-upload>
                        </div>
                        <a class="red-text extend-btn"
                           @click="showExample = true;">查看示例</a>
                    </div>
                </el-form-item>

                <el-form-item label="数字证书："
                              prop="cert">
                    <el-upload accept="application/x-x509-ca-cert"
                               ref="certUpload"
                               :class="{'hide-upload':form.cert}"
                               with-credentials
                               action="/seal/record/upload/cert"
                               :http-request="doUploadCert"
                               :file-list="fileList"
                               :on-remove="handleRemove"
                               :before-upload="beforeUploadCert">
                        <el-button type="text"><i class="el-icon-upload2 grey-text"></i> 上传数字证书文件</el-button>
                        <el-popover trigger="hover">
                            <p class="grey-text">
                                请上传该电子印章配套的数字证书，如有疑问<br>
                                请咨询该印章签发机构
                            </p>
                            <span class="grey-text help-icon"
                                  slot="reference">
                                <i class="el-icon-question"></i>
                            </span>
                        </el-popover>
                    </el-upload>
                </el-form-item>

                <el-form-item label=" ">
                    <el-button type="primary"
                               @click="doSubmit"
                               size="medium">确&nbsp;&nbsp;&nbsp;&nbsp;定</el-button>
                </el-form-item>
            </el-form>
        </div>

        <!-- 裁剪 -->
        <croper v-else
                :img-url="imgUrl"
                seal-type="normal"
                data-type="base64"
                :specs="sealOptions"
                :show-example.sync="showExample"
                @onSaveImage="doSaveImage"
                @onCancel="doCancel"></croper>

        <el-dialog title="印章剪裁示例"
                   :show-close="false"
                   :visible.sync="showExample"
                   width="790px">
            <div class="cropper-example-container">
                <div class="cropper-example-item">
                    <img class="item-img"
                         src="../../assets/images/seal/cropper-example001.png"
                         alt="">
                </div>
                <div class="cropper-example-item">
                    <img class="item-img"
                         src="../../assets/images/seal/cropper-example002.png"
                         alt="">
                </div>
                <div class="cropper-example-item">
                    <img class="item-img"
                         src="../../assets/images/seal/cropper-example003.png"
                         alt="">
                </div>
            </div>
            <div slot="footer"
                 class="text-center">
                <el-button type="primary"
                           @click="showExample = false">我知道了</el-button>
            </div>
        </el-dialog>
    </page-container>
</template>

<script>
import PageContainer from '../../components/container.vue';
import Croper from '../../components/croper/index.vue';

export default {
    name: 'SealCreate',
    components: { PageContainer, Croper },
    props: {
        hideNavigate: Boolean
    },
    data () {
        return {
            // 印章规格
            sealOptions: [
                {
                    height: 42,
                    key: 'CIRCULAR_42',
                    label: '圆形（直径42mm）',
                    type: 'CIRCULAR',
                    width: 42
                }
            ],
            showCropper: false,
            showExample: false,
            // 表单数据
            form: {
                seal_name: "",
                pic_key: "",
                cert: "",
            },
            rules: {
                seal_name: [{ required: true, message: '请输入印章名称', triggle: 'blur' }],
                cert: [{ required: true, message: '请上传数字证书文件', triggle: 'blur' }],
                pic_key: [{ required: true, message: '请上传印章图片', triggle: 'blur' }]
            },
            imgUrl: '',
            fileList: []
        };
    },
    methods: {
        /**
         * 证书预上传
         */
        beforeUploadCert (file) {
            let type = file.name.split('.')[1].toUpperCase();
            let types = ['CER'];
            let img = file.size ? file : file.target.files[0];
            const isLt5M = img.size / 1024 / 1024 < 5;

            if (!types.includes(type)) {
                this.$message.error('文件仅支持cer格式！');
                return false;
            }


            if (!isLt5M) {
                this.$message.error('上传图片大小不能超过 5MB！');
                return false;
            }
            return types.includes(type) && isLt5M;
        },

        handleRemove () {
            this.form.cert = '';
            this.fileList.shift();
        },

        /**
         * 证书上传
         */
        async doUploadCert (req) {
            try {
                this.loading = this.$loading({
                    text: '加载中...'
                });
                let formData = new FormData();
                formData.append('file', req.file);
                let resp = await this.axios({
                    url: req.action,
                    method: 'POST',
                    data: formData
                });
                if (resp.data.code === 0) {
                    this.fileList.push(req.file);
                    this.form.cert = resp.data.result;
                    this.$refs['create'].clearValidate(['cert']);
                } else {
                    this.fileList.shift();
                    this.form.cert = '';
                    this.$message.error(resp.data.message);
                }
            } catch (error) {
                this.fileList.shift();
                this.form.cert = '';
                console.log(error);
            } finally {
                this.loading && this.loading.close();
            }
        },

        /**
         * 提交表单
         */
        async doSubmit () {
            try {
                let resp, requsetData = new FormData();
                await this.$refs.create.validate();

                let params = this.Utils.deepClone(this.form);
                // 处理成formdata 数据
                for (let key in params) {
                    requsetData.append(key, params[key]);
                }
                resp = await this.axios({
                    url: '/seal/record/create',
                    method: 'POST',
                    data: requsetData
                });
                resp = resp.data;
                if (resp.code === 0) {
                    this.$message.success('成功创建备案');
                    this.$router.back();
                } else {
                    this.$message.error(resp.message);
                }
            } catch (error) {
                console.warn(error);
            }
        },

        //上传图片
        uploadImg (file) {
            let type = file.name.split('.')[1].toUpperCase();
            let types = ['JPG', 'PNG', 'JPEG', 'GIF'];
            let img = file.size ? file : file.target.files[0];
            const isLt5M = img.size / 1024 / 1024 < 5;

            if (!types.includes(type)) {
                this.$message.error('文件仅支持png，jpg，gif，jpeg格式！');
                return false;
            }


            if (!isLt5M) {
                this.$message.error('上传图片大小不能超过 5MB！');
                return false;
            }

            let reader = new FileReader();
            reader.onload = e => {
                this.imgUrl = e.target.result;
                this.showCropper = true;
            };
            reader.readAsDataURL(img);
            this.form.pic_type = type;
            return false;
        },

        // 取消
        doCancel () {
            this.showCropper = false;
        },

        back () {
            if (this.showCropper) {
                this.showCropper = false;
            } else {
                this.$router.back();
            }
        },

        // 保存裁剪的图片
        async doSaveImage () {
            this.loading = this.$loading({
                text: '印章图片生成中...'
            });
            try {
                let resp, imgBase64 = arguments[1] || '';
                let formData = new FormData();
                formData.append('imgBase64', imgBase64);
                this.imgUrl = imgBase64;
                this.showCropper = false;
                resp = await this.axios({
                    url: '/seal/base64/upload',
                    method: 'POST',
                    data: formData
                });
                resp = resp.data;
                if (resp.code === 0) {
                    this.form.pic_key = resp.fileKey;
                } else {
                    this.form.pic_key = '';
                    this.$message.error(resp.message);
                }
            } catch (error) {
                this.form.pic_key = '';
                console.log(error);
            } finally {
                this.loading && this.loading.close();
            }
        }
    }
};
</script>

<style lang="less">
.seal-create {
    .upload-component .el-upload-dragger {
        background-color: @background-color-primary !important;
    }
    .el-icon-close-tip {
        display: none !important;
    }
    .el-upload-dragger {
        position: relative;
        img {
            margin: 0 auto;
        }
        .img-model {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
            transition: all 0.3s;

            &:hover {
                opacity: 1;
                color: @white;
                background: @black-opacity-5;
            }
        }
    }
}
.cropper-example-container {
    overflow: hidden;
    .cropper-example-item {
        width: 230px;
        float: left;
        margin: 10px 10px;
        .item-img {
            display: block;
            width: 100%;
        }
    }
}
.hide-upload {
    .el-upload {
        display: none;
    }
}
.croper-dialog {
    .el-dialog__header {
        display: none;
    }
    .el-dialog__body {
        padding: 0;
        height: 100%;
    }
}
</style>
<style lang="less" scoped>
.seal-create {
    .form-item-width {
        width: 360px;
    }
    .help-icon {
        margin-left: 20px;
    }
    .small-font {
        padding: 20px 20px 10px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        span {
            display: inline-block;
            cursor: pointer;
            &:hover {
                color: @red;
            }
        }
    }
    .create-form-container {
        width: 640px;
        margin: 0 auto;
        padding: 40px 0;
    }
    .create-form {
        margin-top: 30px;
    }
    .upload-icon {
        display: inline-block;
        font-size: 64px;
        margin-top: 35px;
    }
    .horizonal-conatiner {
        display: flex;
        .extend-btn {
            margin-left: 10px;
            height: 40px;
            cursor: pointer;
        }
    }
}
</style>